import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PlatformApiService } from '../../services/platform-api.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'cw-ci-msp-dashboard',
  templateUrl: './msp-dashboard.component.html',
  styleUrls: ['./msp-dashboard.component.scss']
})
export class MspDashboardComponent implements OnInit {
  totalAccounts = 0;
  totalAccountsChg = 0;
  created = 0;
  createdChg = 0;
  notStarted = 0;
  inProgress = 0;
  completed = 0;
  notStartedPerc = 0;
  inProgressPerc = 0;
  completedPerc = 0;

  columnsToDisplay = ['name', 'contact', 'location', 'email', 'progress', 'score-history'];
  assessments: MatTableDataSource<any>;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) {
  }

  ngOnInit() {

    this._platformApi.getAssessmentSummaryData(this._sessionService.getCurrentAccount().id).subscribe(data => {
      this.totalAccounts = data[0].totalAccounts;
      this.notStarted = data[0].notStarted;
      this.inProgress = data[0].inProgress;
      this.completed = data[0].completed;
      this.created = data[0].created;
      this.createdChg = 0;
      this.totalAccountsChg = 0;
      if (this.created > 0) {
        this.notStartedPerc = Math.round(this.notStarted / this.created * 100);
        this.inProgressPerc = Math.round(this.inProgress / this.created * 100);
        this.completedPerc = Math.round(this.completed / this.created * 100);
      }
    });
  }

  getProgressPercent(progress) {
    return `${progress}%`;
  }

  scoreLabel(value: number): string {
    return `${Math.round(value)}`;
  }

  scoreDialClass(value:number):string {
    if (value < 50) {
      return 'small low-score';
    } else if (value < 80) {
      return 'small medium-score';
    } else {
      return 'small high-score';
    }
  }

  addAssessment() {
    console.log('Adding assessment');
  }
}
